export function supportedRegionInCountry(country: string) {
  return country === 'US' || country === 'CA';
}
